import { useEffect, useState } from 'react';
import { useGrippContext } from '../grippContext';
import { useStorageKeys } from './useStorageKeys';

/**
 * Issue ids a signed-out visitor touched in THIS browser, written by the web
 * anonymous flows under `anonymousIssueIds`. Registration sends them so the
 * server can re-attribute the anonymous issues and messages. The deferred
 * deep link carries the same list for the app-install path; this is the
 * in-browser half, since a web visitor who signs up never goes through a
 * deep link.
 */
export const useStoredAnonymousIssueIds = (): string[] => {
  const [ids, setIds] = useState<string[]>([]);
  const { storageHandler } = useGrippContext();
  const storageKeys = useStorageKeys();

  useEffect(() => {
    const load = async () => {
      const stored = await storageHandler.getItem(
        storageKeys.anonymousIssueIds
      );
      if (!stored) {
        setIds([]);
        return;
      }
      try {
        const parsed: unknown = JSON.parse(stored);
        setIds(
          Array.isArray(parsed)
            ? parsed.filter((x): x is string => typeof x === 'string' && !!x)
            : []
        );
      } catch {
        setIds([]);
      }
    };
    load();
  }, [storageHandler, storageKeys.anonymousIssueIds]);

  return ids;
};
